import { MemberRole } from "../graphql-types";

/**
 * Returns true if given role is specifically the 'super admin' role
 */
export const isSuperAdminRole = (role: string | undefined) =>
  role === MemberRole.super_admin;
